export default "__VITE_ASSET__c177138f__"